import Link from 'next/link';
import { Segment } from '../../components/cohort/HowDoI/HowDoI';

export const BorrowingPowerContent: Segment = {
  header: 'Max my borrowing power',
  imageUrl: '/next-assets/images/cohort/athena-maxborrowing-superpower.svg',
  imageAlt: "ATHENA'S BORROWING POWER SUPERPOWERS",
  gridContent: [
    {
      title: 'Borrower friendly policy',
      description: 'Get the dream home you want - fast - with more borrowing power thanks to our friendly policies.',
    },
    {
      title: 'Tools and expertise',
      description: (
        <span>
          Use our <Link href="/calculators/buying">borrowing power calculator</Link> to do the maths; text or talk to
          our dedicated team of Aussie experts to workshop your scenario.
        </span>
      ),
    },
    {
      title: 'Money saving hacks that last',
      description:
        'Get more than just borrowing power with fee-free offsets, great rates that stay great, and fiercely fair value.',
    },
  ],
  quote: {
    author: 'Jess, Athena Loan Expert',
    quote: `“I had a customer who couldn’t find a lender that would allow 
      her to borrow the amount she wanted. She was beyond shocked 
      at how much she could borrow with Athena thanks to 
      our policies and we got her application submitted the same 
      day over the phone.”`,
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-1.png',
  },
};

export const ActNowContent: Segment = {
  header: 'Act now',
  imageUrl: '/next-assets/images/cohort/athena-actnow-superpower.svg',
  imageAlt: "ATHENA'S ACT NOW SUPERPOWERS",
  gridContent: [
    {
      title: 'Super fast, accurate pre-approval',
      description:
        "Your credit approved 90-day season pass is locked in and if rates change, your borrowing power won't.",
    },
    {
      title: 'Max borrowing power',
      description: 'Athena is friendlier to borrowers, helping you get more. Calculate yours in just 3 minutes.',
    },
    {
      title: 'Rapid responses from local experts',
      description: 'When you need answers fast, SMS your team of dedicated experts. No waiting on hold!',
    },
  ],
  quote: {
    author: 'Molly, Home Loan Wrecker',
    quote: '“We put an offer on a house that same day.”',
    isTrustPilot: true,
  },
};

export const BuyNextPropertyContent: Segment = {
  header: 'Buy my next property',
  imageUrl: '/next-assets/images/cohort/athena-nexthome-superpower.svg',
  imageAlt: "ATHENA'S NEXT HOME SUPERPOWERS",
  gridContent: [
    {
      title: 'Fast access to equity',
      description: (
        <span>
          Use the <Link href="/calculators/equity">equity in your property</Link> to purchase your next one. We also
          make it fast and easy to maximise your loan top-up.
        </span>
      ),
    },
    {
      title: 'Super fast, accurate pre-approval',
      description:
        "Your credit approved 90-day season pass is locked in and if rates change, your borrowing power won't.",
    },
    {
      title: 'Rapid responses from local experts',
      description: 'When you need answers fast, SMS your team of dedicated Loan Experts. No waiting on hold!',
    },
  ],
  quote: {
    author: 'Rach, Athena Loan Expert',
    quote:
      '“We recently completed a top-up request for an existing customer who used the funds to buy a property for his son to live in. The top-up was completed in five days and we unconditionally approved the loan for their property purchase in one day.”',
    isTrustPilot: false,
    avatarUrl: '/next-assets/images/cohort/how-do-i-le-3.png',
  },
};
